export default __webpack_public_path__ + "static/media/hamburguer-product.58b30cdf.png";